import { gql } from '@apollo/client';

const GET_PROGRAM_CONFIG = gql`
  query GetProgramConfig($filter: ProgramConfigInput!) {
    programConfig(filter: $filter) {
      locales {
        displayTags {
          key
          value
        }
      }
    }
  }
`;

export default GET_PROGRAM_CONFIG;
